export const SET_INITIALISED = 'SET_INITIALISED';

export const setInitialised = value => ({
  type: SET_INITIALISED,
  value
});
